import script from "./jmqzManage.vue?vue&type=script&setup=true&lang=js"
export * from "./jmqzManage.vue?vue&type=script&setup=true&lang=js"

import "./jmqzManage.vue?vue&type=style&index=0&id=3188744c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3188744c"]])

export default __exports__